import React from "react";
import styled from "styled-components";
import RadioButton from "sub_components/Common/Radio";

const BodyStyle = styled.div`
  display: flex;
  flex-direction: column;
  .radio-selection {
    margin: 0.8rem;
  }
  .radio-label {
    padding-top: 0.2rem;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.res.medium}) and (max-width: ${(props) =>
      props.theme.res.high}) {
    .radio-selection {
      margin: 1rem;
      margin-bottom: 2rem;
    }
  }
  @media screen and (min-width: ${(props) => props.theme.res.high}) {
    .radio-selection {
      margin: 1rem;
      margin-bottom: 2rem;
    }
  }
`;

const OPTIONS = [
  { name: "Member", value: "member" },
  { name: "Owner", value: "owner" },
  { name: "Shared User", value: "shared user" },
];

export const RoleUpdateModalBody = ({ text, owners, user, setRole, role }) => {
  let filteredOptions = OPTIONS.filter(
    (option) => option.value !== user?.role.toLowerCase()
  );
  filteredOptions =
    owners.length >= 3
      ? OPTIONS.filter((option) => option.value !== "owner")
      : filteredOptions;

  const displayText =
    owners.length >= 3
      ? `You currently have ${owners.length} owners on this account. To add additional owners please submit a support request .`
      : text;

  return (
    <BodyStyle>
      <div className="body10">{displayText}</div>
      <RadioButton
        callback={setRole}
        name="roles"
        value={role}
        hidden={false}
        toggle={true}
        options={filteredOptions}
        cypressId="dc"
        id="dc"
      />
    </BodyStyle>
  );
};
